import { render, staticRenderFns } from "./procedure-template-header.vue?vue&type=template&id=90be67c6&"
import script from "./procedure-template-header.vue?vue&type=script&lang=js&"
export * from "./procedure-template-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports